"use client"

import clsx from "clsx"
import { ReactNode } from "react"
import { NpIcon } from "../../components/NpIcon"

export type NpStaticTooltipProps = {
  openSide?: "left" | "right"
  expanded?: boolean
  onClick?: () => void
  children: ReactNode
}

export const NpStaticTooltip = ({ openSide = "right", expanded, onClick, children }: NpStaticTooltipProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx("flex rounded-full", {
        "justify-end": openSide === "left",
        "justify-start": openSide === "right",
      })}
    >
      {/* Adding pointer-events-none makes it easier to find clicks outside the buttons. */}
      <div
        className={clsx(
          "bg-np-green/70 hover:bg-np-green/80 pointer-events-none flex h-8 items-center overflow-hidden rounded-full p-1 text-sm font-light text-white backdrop-blur-xs transition-[max-width,background-color] ease-in-out",
          {
            "max-w-8": !expanded,
            "w-full max-w-full": expanded,
            "origin-right flex-row-reverse": openSide === "left",
          },
        )}
      >
        <NpIcon name="add" className={clsx("size-6 transition-transform", expanded && "rotate-135")} />

        <div
          className={clsx("overflow-hidden whitespace-nowrap transition-opacity ease-in", {
            "opacity-0": !expanded,
            "pr-1 pl-3": openSide === "left",
            "pr-3 pl-1": openSide === "right",
          })}
        >
          {children}
        </div>
      </div>
    </button>
  )
}
